import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Seccion from 'components/Modificaciones/Seccion'

function Radio() {
	
	// render
	return (
		<Container fluid id="modificaciones-radio" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<h1>Contenido de la sección</h1>
					<hr />
					<Seccion
						nombreSeccion="radio"
					/>
				</Col>
			</Row>
		</Container>
	)
}

export default Radio